module.exports = __webpack_public_path__ + "media/images/homes/work_offline2x-3ed74834fcb141dd6976ba0ba1efa3e5.png";